
export const CALL_CUSTOMER = 'call_customer'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/escalation/task-name.js